import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import logo from "../assets/images/sova_orange_login.png";
import {
  getToken,
  getUser,
  removeUserSession,
  setUserSession,
} from "../utils/Common";

export const Login = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  let navigate = useNavigate();
  var token;

  const refreshPage = () => {
      navigate(0);
  }

  useEffect(() => {
    if (sessionStorage.getItem("token") !== null && sessionStorage.getItem("token") !== undefined ) navigate("/")
    else navigate("/login")
  }, [navigate]);

  const handleLogin = () => {
    setError(null);
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);
    
    const dataToSend = new URLSearchParams(formData.entries());
    
    fetch(props.rest, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: dataToSend,
    })
      .then((response) => {
        if (response.status === 200) {
          token = response.headers.get("Authorization");
          var text = response.text();
          setError(null);
          return text;
        } else {
          removeUserSession();
          setError("Neuspješna prijava, molimo provjerite unešene podatke i pokušajte ponovno");
          return null;
        } 
      })
      .then((data) => { 
        if (data !== null ) {
          setUserSession(token, data);
          navigate("/");
        } else {
          handleLogout();
        }
      }).then(() => {
        if(error !== null && error !== undefined ) handleLogout();
        navigate("/login");
      });
  };

  const handleLogout = () => {
    removeUserSession();
  };

  return (
    <div className="login-page-container">
      <div>
        <div className="login-page-logo-title">
          <img src={logo} alt="Logo" height={50} />
          <small>e-Dnevnik</small>
        </div>
        {getUser() != null && getToken() != null ? (
          <div className="login-page-element-wrapper">
            <p>Uspješno ste prijavljeni!</p>
            <Button
              label="Odjavi se"
              icon="pi pi-sign-out "
              className="login-page-logout-button"
              onClick={handleLogout}
            />
          </div>
        ) : (
          <div className="login-page-element-wrapper">
            <span>
              <label htmlFor="username" className="login-page-label">
                Korisničko Ime:
              </label>
              <InputText
                id="username"
                autoComplete="off"
                type="text"
                value={username}
                className="login-page-input"
                onChange={(e) => setUsername(e.target.value)}
              />
            </span>
            <span>
              <label htmlFor="password" className="login-page-label">
                Lozinka:
              </label>
              <InputText
                id="password"
                autoComplete="off"
                type="password"
                value={password}
                className="login-page-input p-password p-component"
                onChange={(e) => {
                  if (e.target.value.length < 3) {
                    setError("Password too short!!!");
                  } else setError(null);
                  setPassword(e.target.value);
                }}
              />
            </span>
            {error && <div className="login-page-error-message">{error}</div>}
            <Button
              label="Prijavi se"
              icon="pi pi-sign-in"
              className="login-page-button"
              onClick={() => {
                handleLogin();
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
